import { createTableSettingSelector } from '../../../../form/state/table-state-helper'
import { selectOwnState as selectParentState } from '../../selector'
import { REDUCER_NAME } from './const'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectTableSetting = createTableSettingSelector(selectOwnState)



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/info-table/selector.js